import { Routes } from "@angular/router";
import { authGuard } from "./auth/auth.guard";
import { ContentLayoutComponent } from "./layouts/content-layout/content-layout.component";
import { LoginPage } from "./pages/login/login";

export const routes: Routes = [
	{
		path: "home",
		component: ContentLayoutComponent,
		canActivate: [authGuard],
		children: [
			{
				path: "",
				loadChildren: () => import("./modules/home/home.routing").then((m) => m.HomeRoutingModule),
			},
		],
	},
	{
		path: "login",
		component: LoginPage,
	},
	{
		// OAuth callback (redirectUri): the APP_INITIALIZER consumes the code
		// before routing; by the time the router runs this is a plain redirect.
		path: "redirect",
		redirectTo: "/home/dashboard",
	},
	{
		// AuthService.navigateToLoginPage targets /should-login.
		path: "should-login",
		redirectTo: "/login",
	},
	{
		// Onboarding: authenticated users without an account membership create
		// their company account + first site here (full-screen, no layout).
		path: "register",
		loadChildren: () => import("@partikelart/identity/feature-portal").then((m) => m.identityOnboardingRoutes),
	},
	{
		// Full-screen error page (GlobalErrorHandler navigates here on fatal
		// errors; also serves as the 404 target via the wildcard below).
		path: "error",
		loadComponent: () => import("./pages/error-page/error-page").then((m) => m.ErrorPage),
	},
	{
		path: "",
		redirectTo: "/home/dashboard",
		pathMatch: "full",
	},
	{
		path: "**",
		loadComponent: () => import("./pages/error-page/error-page").then((m) => m.ErrorPage),
		data: { notFound: true },
	},
];
